<script setup>
  import { onMounted, ref, useTemplateRef, watch } from 'vue'
  import ActiveItem from '@/components/Event/ActiveItem.vue'

  const active = useTemplateRef('active')

  const open = ref(false)
  const bodyHeight = ref(0)

  const props = defineProps({
    item: Object
  })

  watch(open, () => {
    if (open.value) {
      const activeItem = active.value.querySelector('.course-events-active-item')
      bodyHeight.value = activeItem.offsetHeight
    } else {
      bodyHeight.value = 0
    }
  })

</script>

<template>
  <div
    class="event-item-member border-t last:border-b border-border"
  >
    <div
      class="event-item-member-header divide-x divide-border grid grid-cols-4"
      @click="open = !open"
    >
      <div class="event-item-member-header-text col-span-3 text-primary py-5 flex flex-row items-center justify-between">
        {{ item.seminar }}
        <AppIcon
          class="mx-2"
          name="Chevron"
          :class="{ 'rotate-180': open }"
        />
      </div>
      <div class="event-item-member-header-date flex flex-col border-r border-border items-center justify-center">
        <span
          class="text-xl text-headline"
        >
          {{ item.dates[0].day }}
        </span>
        <span
          class="text-base text-headline"
        >
          {{ item.dates[0].weekday.slice(0, 3) }}
        </span>
      </div>
    </div>
    <div
      ref="active"
      class="event-item-member-details overflow-hidden transition-all duration-300"
      :style="{ maxHeight: `${bodyHeight}px` }"
    >
      <ActiveItem
        :activeItem="item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .event-item-member-header-text :deep(svg)
  {
    @apply w-3 h-3 transition-transform;

  }

  .event-item-member-header-text :deep(path) {
    fill: #C83528 !important;
  }
</style>
